import { ProgramResources } from './ProgramResources';

export default ProgramResources;
